<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
                <div class="topImgTitle">企业联盟</div>
                <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
                <div class="e-flex menuContent">
                    <img class="ic_home" src="@/assets/images/ic_home.png">
                    <div class="pointer" @click="goMainPage()">首页</div>
                    <div>/</div>
                    <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/unionEnterprises/index', query: {}})">企业联盟</div>
                    <div>/</div>
                    <div>正文</div>
                </div>
            </div>
        </div>
        <div class="e-flex" style="justify-content: center;">
            <div class="ued_whiteContent">
                <div class="e-flex ued_companyNameFlex">
                    <div class="ued_companyName e-line-2">{{ info.name }}</div>
                    <div class="ued_logoContent e-flex">
                        <img class="ued_logoImg" :src="info.iconUrl">
                    </div>
                </div>
                <div class="ued_companyNameInfoContent">
                    <div class="ued_title">企业简介</div>
                    <div class="ued_companyNameDes" v-html="info.description"></div>
                    <div class="ued_title">发展历程</div>
                    <div class="ued_companyNameDes" v-html="info.course"></div>
                </div>
            </div>
        </div>
        
    </div>
  </template>
  
  <script>
    import '../../styles/unionEnterprises.css'
    export default {
      name: 'unionEnterprisesDetail',
      data () {
        return {
          from: '',
          id: '',
          info: {}
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
              url: 'companyLeague/detail?id=' + this.id,
              method: 'get',
              data: {}
          }).then(res => {
              this.info = res.data
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/unionEnterprises/unionEnterprisesDetail.vue